import { render, staticRenderFns } from "./designerOther.vue?vue&type=template&id=18554cc7"
import script from "./designerOther.vue?vue&type=script&lang=js"
export * from "./designerOther.vue?vue&type=script&lang=js"
import style0 from "./designerOther.vue?vue&type=style&index=0&id=18554cc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports